import { useNavigate } from 'react-router-dom';
import { Terminal, Zap, ArrowRight, CheckCircle2, Circle } from 'lucide-react';
import { useDiagnosticContext } from '../../../context/DiagnosticContext';
import '../DiagnosticPremium.css';

export function ChooseMethod() {
  const navigate = useNavigate();
  const { setCurrentStep, setSelectedMode } = useDiagnosticContext();

  const handleManualSelect = () => {
    setSelectedMode('manual');
    setCurrentStep('download');
  };

  return (
    <div className="stepContainer fade-up">
      <header className="stepHeader" style={{ textAlign: 'center', marginBottom: '48px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 900, marginBottom: '16px' }}>How would you like to diagnose your PC?</h1>
        <p style={{ color: '#9999a8', fontSize: '18px' }}>Choose the diagnostic method that works best for you.</p>
      </header>
      
      <div className="modeGrid">
        {/* Manual Diagnostic (.bat) */}
        <div className="modeCardWrapper" onClick={handleManualSelect}>
          <div className="modeBadge">RECOMMENDED</div>
          <div className="modeCardInner">
            <div className="modeIcon"><Terminal size={28} /></div>
            <div className="modeContent">
              <h3>Smart Manual Diagnostic</h3>
              <p>Download a safe, read-only script that collects your PC's health data in seconds. No software to install.</p>
              <ul className="modeFeatures">
                <li><CheckCircle2 size={14} color="var(--green)" /> One-click .bat scanner</li>
                <li><CheckCircle2 size={14} color="var(--green)" /> Safe, read-only collection</li>
                <li><CheckCircle2 size={14} color="var(--green)" /> AI-powered analysis</li>
              </ul>
            </div>
            <div className="modeAction">Start Manual Diagnostic <ArrowRight size={16} /></div>
          </div>
        </div>

        {/* Automatic Scan (Coming Soon) */}
        <div className="modeCardWrapper disabledMode">
          <div className="modeBadge" style={{ background: '#333', color: '#999' }}>COMING SOON</div>
          <div className="modeCardInner">
            <div className="modeIcon"><Zap size={28} /></div>
            <div className="modeContent">
              <h3>Automatic One-Click Scan</h3>
              <p>A lightweight app that automatically handles everything from scanning to report generation.</p>
              <ul className="modeFeatures">
                <li><Circle size={14} color="#666" /> Full system deep-scan</li>
                <li><Circle size={14} color="#666" /> Automatic repair suggestions</li>
                <li><Circle size={14} color="#666" /> Zero technical steps</li>
              </ul>
            </div>
            <div className="modeAction">Notify Me on Release <ArrowRight size={16} /></div>
          </div>
        </div>
      </div>

      <div className="helperText" style={{ textAlign: 'center', marginTop: '48px', color: '#666677', fontSize: '14px' }}>
        <p>
          Both methods are 100% private. We only collect technical system data, never your personal files or passwords.
        </p>
        <p style={{ marginTop: '16px' }}>
          <button 
            className="advancedLink" 
            onClick={() => navigate('/diagnostic/advanced')}
          >
            Looking for the legacy PowerShell guide? Click here.
          </button>
        </p>
      </div>
    </div>
  );
}
